// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__f-cBj","content":"style__content__XmdWP","panel":"style__panel__GFQ6g","panelHead":"style__panelHead__0c2mr","panelBody":"style__panelBody__AmxHG"};